import apiClient from '@/api/client'
import type { ApiResponse } from '@/types/api'
import type { Persona } from '../types'
import type { PersonaFormData } from '../types'

export const personasApi = {
  fetchAll: () =>
    apiClient.get<ApiResponse<Persona[]>>('/personas'),

  create: (data: PersonaFormData) =>
    apiClient.post<ApiResponse<Persona>>('/personas', data),

  update: (id: string, data: PersonaFormData) =>
    apiClient.patch<ApiResponse<Persona>>(`/personas/${id}`, data),

  remove: (id: string) =>
    apiClient.delete<void>(`/personas/${id}`),

  setDefault: (id: string) =>
    apiClient.patch<ApiResponse<Persona>>(`/personas/${id}/default`, {}),
}
